import React, { useState } from "react";
import "./Contact.css";
import contact1 from "./../../images/contact1.png";

const Contact = () => {
  const [status, setStatus] = useState("");
  const [data, setData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const formSubmit = async (event) => {
    event.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch("https://formspree.io/f/xyzjoepp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: data.fullname,
          phone: data.phone,
          email: data.email,
          subject: data.subject,
          message: data.message,
        }),
      });

      if (response.ok) {
        setStatus("✅ Message sent successfully!");
        setData({
          fullname: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setStatus("❌ Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setStatus("❌ Network error. Please try again later.");
    }

    setTimeout(() => {
      setStatus("");
    }, 5000);
  };

  return (
    <>
      <section className="Contact" id="contact">
        <div className="container top">
          <div className="heading text-center">
            <h4>CONTACT</h4>
            <h1>Contact With Me</h1>
          </div>

          <div className="content d_flex">
            <div className="left">
              <div className="box box_shodow">
                <div className="img">
                  <img src={contact1} alt="" width="100%" />
                </div>
                <div className="details">
                  <h1>Nasif Jihan</h1>
                  <p>MERN Developer</p>
                  <p>
                    I am available for freelance work. Connect with me via and
                    call in to my account.
                  </p>{" "}
                  <br />
                  <p>Phone: +8801983794542</p>
                  <p>Email: nasifzeehan1@gmail.com</p>
                  {/* <br />
                  <span>FIND WITH ME</span>
                  <div className="button f_flex">
                    <a
                      href="https://www.facebook.com/nasifjihan"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn_shadow">
                        <i className="fab fa-facebook-f"></i>
                      </button>
                    </a>
                    <a
                      href="https://www.instagram.com/nasifjihan"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn_shadow">
                        <i className="fab fa-instagram"></i>
                      </button>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/nasifjihan"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn_shadow">
                        <i className="fab fa-linkedin-in"></i>
                      </button>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="right box_shodow">
              <form onSubmit={formSubmit}>
                <div className="f_flex gap">
                  <div className="input row">
                    <span>YOUR NAME</span>
                    <input
                      type="text"
                      name="fullname"
                      value={data.fullname}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="input row">
                    <span>PHONE NUMBER </span>
                    <input
                      type="number"
                      name="phone"
                      value={data.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="input">
                  <span>EMAIL </span>
                  <input
                    type="email"
                    name="email"
                    value={data.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="input">
                  <span>SUBJECT </span>
                  <input
                    type="text"
                    name="subject"
                    value={data.subject}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="input">
                  <span>YOUR MESSAGE </span>
                  <textarea
                    cols="30"
                    rows="10"
                    name="message"
                    value={data.message}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <button className="btn_shadow">
                  SEND MESSAGE <i className="fa fa-long-arrow-right"></i>
                </button>
                {status && (
                  <p style={{ marginTop: "1rem", color: "green" }}>{status}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
